<div class="acura-screen">  
   <div *ngIf="isRenew" class="top-ribbon">
        <p class="header-text">{{displayedText.trialExpiringSoonMessage}}</p>
    </div>
    <div class="layout">
    <div class="left-section" [ngClass]="{'if-renew': isRenew}">
        <div class="left-container">
            <p class="eclipse"></p>
            <h2 *ngIf="!isRenew" class="top-text" style="white-space: pre-line;">{{displayedText.activateText}}</h2>
            <h2 *ngIf="isRenew" class="top-text" style="white-space: pre-line;">{{displayedText.subscribeText}}</h2>
            <qrcode *ngIf="url"  [width]="200" [qrdata]="url" [errorCorrectionLevel]="'M'" [size]="200"  class="qrcodeImage"></qrcode>
            <p *ngIf="!isRenew" class="bottom-text" style="white-space: pre-line;">{{displayedText.scanMessage.trial}}</p>
            <p *ngIf="isRenew" class="bottom-text ">{{displayedText.scanMessage.subscription}}</p>
            <div class="toggle-container" *ngIf="country === 'CA'">
                <span class="toggle-text">{{displayedText.englishLanguageTitle}}</span>
                <label class="toggle-switch">
                    <input type="checkbox"  
                    (change)="onLanguageChange($event)"/>
                    <span class="slider"></span>
                    </label>
                <span class="toggle-text">{{displayedText.frenchLanguageTitle}}</span>
              </div>
        </div>
    </div>
    <div class="center-phone" [ngClass]="{'if-renewMobile': isRenew}">
    <img  *ngIf="country === 'US'"  src="..\assets\ivi23\AL-mobile.png" alt="Phone" class="phone-img" />
    <img  *ngIf="selectedLanguage === 'en' && country === 'CA'" src="..\assets\ivi23\AL-en-Mobile.png" alt="AL Phone" class="phone-img" />
    <img  *ngIf="selectedLanguage === 'fr'" src="..\assets\ivi23\AL-fr-Mobile.png" alt="AL Phone" class="phone-img" />
    </div>
    <div class="right-panel" [ngClass]="{'if-renewRightPanel': isRenew}">
    <div class="row">
    <img src="..\assets\ivi23\AL-topImage.png" alt="Black Car" class="car-img panel-image image-1" />
    <img src="..\assets\ivi23\AL-remoteStart.png" alt="remote start" class="remote-start" />
    <img *ngIf="selectedLanguage === 'fr'" src="..\assets\ivi23\AL-fr-RemoteStart.png" alt="Fr remote start" class="remote-start" />
    </div>
    <div class="rectangle">
        <img src="..\assets\ivi23\AL-rectangle.png" alt="rectangle" />
    </div>
    <div >
    <img src="..\assets\ivi23\AL-blackCar.png" alt="White Car" class="combined-image panel-image image-2" />
    <img src="..\assets\ivi23\AL-remoteLock.png" alt="remote lock" class="remote-lock" />
    <img *ngIf="selectedLanguage === 'fr'" src="..\assets\ivi23\AL-fr-RemoteLock.png"  alt=" Fr remote lock" class="remote-lock"  />
    </div>
    <div class="rectangle2">
        <img src="..\assets\ivi23\AL-rectangle2.png" alt="rectangle" />
    </div>
    <div class="row">
        <div class="btm-img panel-image image-3">
            <img src="..\assets\ivi23\AL-map.png" alt="map" class="map-img" />            
        </div>
    <img src="..\assets\ivi23\AL-vehicleLocator.png" alt="vehicle locator" class="vehicle-locator" />
    <img *ngIf="selectedLanguage === 'fr'" src="..\assets\ivi23\AL-fr-VehicleLocator.png" alt=" Fr vehicle locator" class="vehicle-locator"  />
    </div>
    <div class="blur-overlay"></div>

</div>
</div>
</div> 